import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as actions from '../actions/homeActions';
import { Field, reduxForm, initialize, formValueSelector } from 'redux-form';

class AddVehicleModalForm extends React.Component {
    toggle(reset) {
        if (reset) {
            this.props.actions.resetForm("addVehicleModal", {
                isFindingVehicle: false,
                attemptedFind: false,
                vehicleReg: "",
                make: "",
                model: "",
                licensePlate: "",
                color:""
            });
        }
        this.props.reset();
       
        this.props.toggle();
    }


    
    isValid() {
        if (this.props.vehicleReg && this.props.make && this.props.model) {
            // this.form.dispatchEvent(new Event('submit')) 
            // this.form.dispatchEvent(new Event('submit'))
            // document.getElementById('myForm').dispatchEvent(new Event('submit', { cancelable: true, bubbles:true }));
        }
        return this.props.vehicleReg && this.props.make && this.props.model;
    }

    render() {
        const {
            handleSubmit,
            submitting,
            isLoading,
            isOpen,
            attemptedFind,
            vehicleReg,
            findVehicle
        } = this.props;
        return (
            <Modal isOpen={isOpen}
                backdrop={"static"}
                className={"modalAddVehicle"}
                toggle={() => this.toggle(!isOpen)}>

                <form onSubmit={handleSubmit} ref={ (ref) => { this.form = ref; } } id="myForm">
                    <ModalHeader toggle={() => this.toggle("")}>Select Vehicle</ModalHeader>
                    <ModalBody>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-md-7">
                                    <label htmlFor="vehicleReg"><b>Registration</b></label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-7">
                                    <Field name="vehicleReg" component="input" type="text" />
                                </div>
                                <div className="col-md-5">
                                    <button className="btn btn-primary find-vehicle" type="button" onClick={() => findVehicle(vehicleReg)}>Find Vehicle</button>
                                </div>
                            </div>

                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                    <label htmlFor="make"><b>Make</b></label>
                                    <Field name="make" disabled={!attemptedFind} component="input" type="text" />
                                    </div>
                                    <div className="col-md-6">
                                    <label htmlFor="model"><b>Model</b></label>
                                    <Field name="model" disabled={!attemptedFind} component="input" type="text" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 mt-2">
                                    <label htmlFor="Color"><b>Color</b></label>
                                        <Field name="color" disabled={!attemptedFind} component="input" type="text" />
                                    </div>
                                </div>
                            </div>
                            {/* )} */}
                            <div className="row">
                                <div className="col-md-12 mt-2">
                                    <span className="text-primary font-weight-bold">Please make sure that your vehicle plate is correct as you risk being clamped if not.  </span>
                                </div>
                            </div>

                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-text mr-auto" onClick={() => this.toggle(true)}>
                            Cancel
                        </button>

                        <button 
                            className="btn btn-primary" 
                            type="submit" 
                            disabled={!attemptedFind || !this.isValid() || isLoading || submitting}>
                            Confirm Vehicle
                        </button>{' '}
                    </ModalFooter>
                    {
                        isLoading ?
                            (
                                <div id="overlay">
                                    <div className="loader" style={{ top: "20%" }}>
                                        Loading...
                                    </div>
                                </div>
                            ) : null
                    }
                </form>
            </Modal>
        );
    }
}

AddVehicleModalForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    reset: PropTypes.func,
    actions: PropTypes.object.isRequired,
    vehicleReg: PropTypes.string,
    attemptedFind: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    findVehicle: PropTypes.func.isRequired,
    make: PropTypes.string,
    model: PropTypes.string,
    color:PropTypes.string
};

const selector = formValueSelector('addVehicle');

function mapStateToProps(state) {

    const vehicleReg = selector(state, 'vehicleReg');
    const make = selector(state, 'make');
    const model = selector(state, 'model');
    const color = selector(state, 'color');

    return {
        initialValues: state.accountDetails.addVehicleModal,
        enableReinitialize: true,
        vehicleReg,
        model,
        make,
        color
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({
    form: 'addVehicle',
    onSubmitSuccess: (result, dispatch, props) => {
        console.log('onSubmitSuccess, ?? ? ?? ? ?? ? ? ?', );
        dispatch(initialize(props.form, props.values));
    }
})(AddVehicleModalForm));


// WEBPACK FOOTER //
// ./src/forms/AddVehicleModalForm.jsx